import getUserAgent from 'functions/getUserAgent';

export const isAndroid = () => {
  const userAgent = getUserAgent();

  return userAgent ? /Android/i.test(userAgent) : false;
};
